var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [(_vm.loading) ? _c('div', {
    class: _vm.theme.loading
  }, [_c('v-spinner', {
    attrs: {
      "block": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Загрузка...")])], 1) : (_vm.error) ? _c('div', {
    class: _vm.theme.error
  }, [_c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.error) + "\n            ")]), _vm._v(" "), _c('v-button', {
    on: {
      "click": _vm.onReload
    }
  }, [_vm._v("\n                Попробовать снова\n            ")])], 1) : (_vm.iframeUrl) ? [_c('div', {
    ref: "fullscreenButtonContainer",
    staticClass: "fullscreenButtonContainer"
  }, [_c('v-button', {
    ref: "fullscreenButton",
    attrs: {
      "title": _vm.isFullscreen ? 'Свернуть' : 'На весь экран',
      "small": ""
    },
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('v-font-icon', {
    attrs: {
      "inherit": ""
    }
  }, [_vm._v(_vm._s(_vm.isFullscreen ? 'fullscreen_exit' : 'fullscreen'))])], 1)], 1), _vm._v(" "), _c('div', {
    ref: "iframeContainer",
    class: ['refinanceIframeContainer', {
      fullscreen: _vm.isFullscreen
    }],
    staticStyle: {
      "height": "600px"
    }
  }, [(_vm.isFullscreen) ? _c('div', {
    ref: "fullscreenBar",
    staticClass: "fullscreenBar",
    staticStyle: {
      "display": "flex !important",
      "justify-content": "flex-end !important",
      "align-items": "center !important"
    }
  }, [_c('v-button', {
    ref: "closeButton",
    staticClass: "closeButton",
    staticStyle: {
      "margin-left": "auto !important",
      "margin-right": "0 !important"
    },
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.exitFullscreen
    }
  }, [_c('v-font-icon', {
    attrs: {
      "inherit": ""
    }
  }, [_vm._v("fullscreen_exit")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('iframe', {
    staticClass: "refinanceIframe",
    attrs: {
      "src": _vm.iframeUrl,
      "width": "100%",
      "height": "100%",
      "frameborder": "0",
      "allow": "fullscreen",
      "scrolling": "auto"
    }
  })])] : _c('div', {
    class: _vm.theme.emptyState
  }, [_c('p', [_vm._v("Не удалось загрузить данные анализа")]), _vm._v(" "), _c('v-button', {
    on: {
      "click": _vm.onReload
    }
  }, [_vm._v("\n                Обновить\n            ")])], 1)], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22302c80","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/refinanceAnalysis/RefinanceAnalysis.vue
// module id = 1140
// module chunks = 0